// @ts-nocheck
export const _Number = (value) => {
  const number = Number(value);
  if (Number.isNaN(number) || !Number.isFinite(number)) return 0;
  return number;
};
export const _NumberToFix = (strValue, decimalPoints = 2) => {
  const value = +strValue;
  if (Number.isNaN(value) || !Number.isFinite(value)) return 0;
  return value?.toFixed(decimalPoints);
};

export const _ParseInt = (param) => {
  const value = Number.parseInt(param);
  if (Number.isNaN(value) || !Number.isFinite(value)) return 0;
  return value;
};
